export enum EvalStatuses {
  All = 'all',
  Upcoming = 'upcoming',
  Ongoing = 'ongoing',
  Closed = 'closed',
  Cancelled = 'cancelled',
  PendingToStart = 'pending to start',
  PendingToClose = 'pending to close',
}

export const EvalStatusLabels: Record<EvalStatuses, string> = {
  [EvalStatuses.All]: 'All',
  [EvalStatuses.Upcoming]: 'Upcoming',
  [EvalStatuses.Ongoing]: 'Ongoing',
  [EvalStatuses.Closed]: 'Closed',
  [EvalStatuses.Cancelled]: 'Cancelled',
  [EvalStatuses.PendingToStart]: 'Pending to start',
  [EvalStatuses.PendingToClose]: 'Pending to close',
};
